import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const VesselSelector = ({ selectedVessel, onVesselChange, vessels }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const vesselOptions = vessels?.map(vessel => ({
    value: vessel?.id,
    label: `${vessel?.name} (${vessel?.imo})`,
    description: `${vessel?.type} • ${vessel?.flag} • Built ${vessel?.yearBuilt}`
  }));

  const filteredOptions = vesselOptions?.filter(option =>
    option?.label?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    option?.description?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

  return (
    <div className="bg-card rounded-lg border p-6 shadow-maritime-sm">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Ship" size={20} className="text-primary" strokeWidth={2} />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">Vessel Selection</h2>
            <p className="text-sm text-muted-foreground">Choose vessel for performance analysis</p>
          </div>
        </div>
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Database" size={16} strokeWidth={2} />
          <span>{vessels?.length} vessels available</span>
        </div>
      </div>
      <div className="space-y-4">
        <Select
          label="Select Vessel"
          placeholder="Search by vessel name or IMO..."
          options={filteredOptions}
          value={selectedVessel}
          onChange={onVesselChange}
          searchable
          className="w-full"
        />

        {selectedVessel && (
          <div className="mt-4 p-4 bg-muted/50 rounded-lg">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
                <span className="text-sm font-medium text-foreground">
                  Real-time data connected
                </span>
              </div>
              <div className="text-xs text-muted-foreground">
                Last update: {new Date()?.toLocaleTimeString()}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VesselSelector;